import React from 'react';
import { vui } from '../core';
import { Tag } from '../tag';
import theme from './theme';
/**
 * Badges are round, non-interactive tags.
 *
 * These components are used for displaying information only; they might be used as a “counter” for push notifications.
 */
export const Badge = vui((props, ref) => {
    const { variant, ...rest } = props;
    const { variants } = theme ?? {};
    const bg = variants[variant ?? 'subtleSandstone'].container.bg;
    const color = variants[variant ?? 'subtleSandstone'].container.color;
    return (React.createElement(Tag, { bg: bg, className: "vui-badge", color: color, isInteractive: false, isRound: true, minW: "20px", ref: ref, ...rest, onDelete: undefined }));
});
export default Badge;
